import { action } from 'satcheljs';

/**

 * action for setting the flag isDirty in the active View state to false

 */
const clearIsDirty = action('clearIsDirty');

export default clearIsDirty;
